import React from 'react';

import {
  Button,
  Container,
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';

import { WysiwygField } from '../../../components';

import './style.scss';

const ParagraphLandingTextImage = ({ id, entity }) => {
  const title = entity.getIn(['field_title', 0, 'value']);
  const link = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const linkTitle = entity.getIn(['field_link', 0, 'title']);
  const linkTarget = entity.getIn(['field_link', 0, 'options', 'attributes', 'target'], '_self');
  const ctaUrl = entity.getIn(['field_cta', 0, 'alias'], entity.getIn(['field_cta', 0, 'uri']));
  const ctaTitle = entity.getIn(['field_cta', 0, 'title']);
  const ctaTarget = entity.getIn(['field_cta', 0, 'options', 'attributes', 'target'], '_self');
  const body = entity.getIn(['field_body', 0, 'processed']);
  const image = entity.getIn(['field_media_item', 0, 'styles', 'paragraph_text_and_image']);
  const caption = entity.getIn(['field_caption', 0, 'value']);
  const flipped = entity.getIn(['field_flipped', 0, 'value']);

  return (
    <Container id={id} className="Paragraph ParagraphLandingTextImage">
      <div className={`row ParagraphLandingTextImage__outer ${flipped ? 'flipped' : ''}`}>
        <div className="ParagraphLandingTextImage__inner__image col-12 col-md-5 col-lg-5">
          <Image
            src={image}
            className="ParagraphLandingTextImage__image"
          />
          {caption && <div className="ParagraphLandingTextImage__caption">{caption}</div>}
        </div>
        <div className="ParagraphLandingTextImage__inner col-12 col-md-7 col-lg-6">
          {title && (
            <h2 className="ParagraphLandingTextImage__title">{title}</h2>
          )}
          <WysiwygField
            property="schema:text"
            className="ParagraphLandingTextImage__body"
            html={body}
          />
          <div className="ParagraphLandingTextImage__buttons">
            {ctaUrl && ctaTitle && (
              <div className="ParagraphLandingTextImage__cta">
                <Button href={ctaUrl} target={ctaTarget}>{ctaTitle}</Button>
              </div>
            )}
            {link && linkTitle && (
              <Button
                className="ParagraphLandingTextImage__link"
                href={link}
                target={linkTarget}
                primary={false}
              >
                {linkTitle}<span className="icon icon-arrow-right icon-variant-2" />
              </Button>
            )}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ParagraphLandingTextImage;
